import styles from './LockedBundleLabel.scss';

const LockedBundleIcon = () => {
    return <div className={styles.icon}></div>;
};

export default LockedBundleIcon;
